import clsx from 'clsx';
import React from 'react';
import { Box } from '../Box';
import { Stack } from '../Stack';
import { Text } from '../Text';
import { DetailListItem } from './DetailListItem';
import { responsiveCssProperties } from '../../utils';
import './DetailList.css';
export function DetailList(props) {
    const { children, title, className, emptyText, labelWidth, hierarchy = 'secondary', ...rest } = props;
    return (React.createElement(Stack, { spacing: "space-200", ...rest },
        typeof title === 'string' ? (React.createElement(Text.H2, { variant: "heading-title-3" }, title)) : (title),
        React.createElement(Box, { elementType: children ? 'table' : 'div', className: clsx('mollie-ui-detail-list', {
                'mollie-ui-detail-list--empty': !children,
                [`mollie-ui-detail-list--${hierarchy}`]: hierarchy,
            }, className), style: responsiveCssProperties('--mollie-ui-detail-list-label-width', labelWidth) }, children ? React.createElement("tbody", null, children) : emptyText)));
}
DetailList.Item = DetailListItem;
//# sourceMappingURL=DetailList.js.map